import React from 'react';
import Spinner from 'react-spinkit';

import { connect } from 'react-redux';
import Cookies from 'js-cookie';

import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';

import { getDeviceId } from '../util/device';

import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { generateDeviceId, storeHistory, mobileDeviceId } from '../store/actions/appActions';

import { fetchDevice, updateDevice } from '../store/actions/deviceActions';
import { fetchMobileStatus } from '../store/actions/mobileActions';
import { fetchUser, clearUser } from '../store/actions/userActions';
import { fireAnalytics } from './utils';
import {
  fetchFeaturedPlaylist,
  fetchUserPlaylists,
  fetchHomePlaylist,
  fetchMyPlaylist,
  fetchActivePlaylist,
  clearFeaturedPlaylist,
  clearUserPlaylists,
  clearActivePlaylist,
} from '../store/actions/playlistActions';
import { set4kQuality, setMute, setQR, setShowArtworkDetails, setSwitchArtwork, setShowLogo, setMatchContent } from '../store/actions/settingActions';
import { fetchSubscription, clearSubscription } from '../store/actions/subscriptionActions';

export class SplashScreen extends React.Component {
  async componentDidMount() {
    const result = await this.checkOnlineStatus();
    if (!result) this.props.history.push('/offline');
    this.changeLogoImage();
    // console.log("This is new design SCAP App");
    // this.checkStorage();
    this.getPlatformInformation();
    // this.loadData();
  }

  async checkOnlineStatus() {
    try {
      const online = await fetch('assets/img/blackdove-logo-2020.png');
      return online.status >= 200 && online.status < 300; // either true or false
    } catch (err) {
      return false; // definitely offline
    }
  }

  changeLogoImage() {
    const successCb = function () {
      console.log('Upgrading logo image is successful');
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      console.log(` Error Code [${errorCode}]: ${errorText}`);
    };

    const options = {
      uri: 'https://assets.blackdove.com/images/Logo.jpg'
    };

    const storage = new Storage();
    storage.changeLogoImage(successCb, failureCb, options);
  }

  checkStorage() {
    // console.log("Checking Internal Storage");
    const that = this;
    const successCb = function (cbObject) {
      const { free } = cbObject;
      if (free > 200000) {
        // console.log("Space Available");
        that.getPlatformInformation();
      } else {
        that.clearInternalStorage();
      }
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      // console.log(" Error Code [" + errorCode + "]: " + errorText);
    };

    const storage = new Storage();
    storage.getStorageInfo(successCb, failureCb);
  }

  clearInternalStorage() {
    const that = this;
    const successCb = function (cbObject) {
      // console.log("Removed all files Internal");
      that.getPlatformInformation();
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      // console.log(" Error Code [" + errorCode + "]: " + errorText);
    };

    const options = {
      device: 'internal' // This will remove all the files in the local storage.
    };

    const storage = new Storage();
    storage.removeAll(successCb, failureCb, options);
  }

  getPlatformInformation() {
    const that = this;
    function successCb(cbObject) {
      // console.log('[Platform Info] : ' + JSON.stringify(cbObject));
      localStorage.setItem('DeviceID', cbObject.serialNumber);
      that.loadData();
    }

    function failureCb(cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;

      // console.log('Error Code [' + errorCode + ']: ' + errorText);
    }

    const deviceInfo = new DeviceInfo();
    deviceInfo.getPlatformInfo(successCb, failureCb);
  }

  async loadData() {
    // console.log('called');

    try {
      const deviceId = getDeviceId();
      fireAnalytics('Launch', 'Starting App', deviceId);
      if (localStorage.getItem('firstLaunchedAt') === null) {
        localStorage.setItem('firstLaunchedAt', new Date());
      }
      await this.props.storeHistory(this.props.history);
      if (!this.props.app.SCAPDeviceId) {
        this.props.generateDeviceId(deviceId);
      }
      localStorage.setItem('DownloadInfo', null);
      let status = await this.props.fetchMobileStatus(this.props.app.SCAPDeviceId);
      const deviceResult = await this.props.fetchDevice(this.props.app.SCAPDeviceId);
      if (deviceResult.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
        let orientation;
        if (window.innerWidth <= window.innerHeight) {
          orientation = 'portrait';
        } else {
          orientation = 'landscape';
        }
        const orientationUpdate = await this.props.updateDevice(this.props.device.data.id, 'orientation', orientation);
        const matchContent = orientationUpdate.success && await this.props.updateDevice(this.props.device.data.id, 'content', true);
        matchContent && await this.props.fetchDevice(this.props.app.SCAPDeviceId);
        status = await this.props.fetchMobileStatus(this.props.app.SCAPDeviceId);
        this.props.updateMatchContent(status.payload.matchContent);
        this.props.updateQuality(status.payload.highQuality);
        this.props.updateMute(status.payload.mute);
        this.props.updateQR(status.payload.qr);
        this.props.updateShowArtDetails(status.payload.details);
        this.props.updateShowLogo(status.payload.logo);

        const emailId = deviceResult.payload.email;
        const { userId } = deviceResult.payload;
        await this.props.mobileDeviceId(userId);
        // TODO: Move this into a redux action.
        //         if (bdAuth.getToken()) {
        const response = await bdReq.post('/emailLogin', { emailId });
        if (response.success) {
          bdAuth._storeToken(response.body);
        }
        //         }

        const fetchUser = await this.props.fetchUser();
        if (fetchUser.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchSubscription = await this.props.fetchSubscription();
        if (fetchSubscription.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
        if (fetchFeaturedPlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchHomePlaylist = await this.props.fetchHomePlaylist();
        if (fetchHomePlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        // const fetchActivePlaylist = await this.props.fetchActivePlaylist(playlistId);
        let fetchActivePlaylist = await this.props.fetchActivePlaylist(
          status.payload.playingCollection
            ? status.payload.playingCollection
            : 'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx'
        );
        if (fetchActivePlaylist.errors === 'No Artworks') {
          fetchActivePlaylist = await this.props.fetchActivePlaylist(
            'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx'
          );
        }
        if (fetchActivePlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const playlists = await this.props.fetchUserPlaylists();
        if (playlists.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }

        let targetPlaylistId;

        if (status.payload.playingCollection) {
          targetPlaylistId = status.payload.playingCollection;
        } else {
          targetPlaylistId = 'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx';
        }

        await this.props.fetchActivePlaylist(targetPlaylistId);
        setTimeout(() => {
          this.props.history.push(`/playlist/${targetPlaylistId}`);
        }, 10);
      } else {
        this.props.clearFeaturedPlaylist();
        this.props.clearUserPlaylists();
        this.props.clearActivePlaylist();
        this.props.clearUser();
        this.props.clearSubscription();
        Cookies.remove('auth__token');
        Cookies.remove('artwork_Interval');
        // const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
        // if (fetchFeaturedPlaylist.type === 'FETCH_FEATURED_PLAYLIST_FAILURE') {
        //   setTimeout(() => {
        //     this.props.history.push('/error');
        //   }, 10);
        //   return;
        // }
        // if (fetchFeaturedPlaylist.errors === 'Error') {
        //   setTimeout(() => {
        //     this.props.history.push('/error');
        //   }, 10);
        //   return;
        // }
        // const fetchHomePlaylist = await this.props.fetchHomePlaylist();
        // if (fetchHomePlaylist.errors === 'Error') {
        //   setTimeout(() => {
        //     this.props.history.push('/error');
        //   }, 10);
        //   return;
        // }
        // const fetchMyPlaylist = await this.props.fetchMyPlaylist();
        // if (fetchMyPlaylist.errors === 'Error') {
        //   setTimeout(() => {
        //     this.props.history.push('/error');
        //   }, 10);
        //   return;
        // }
        setTimeout(() => {
          this.props.history.push('/pair');
        }, 10);
      }
    } catch (e) {
      // console.log('e', e);
    }
  }

  render() {
    return (
      <div className="SplashPage">
        <div className="SplashWrapper">
          <img className="Logo" src="assets/img/blackdove-logo-2020.png" alt="" />
          <Spinner name="folding-cube" color="white" fadeIn="none" style={{ width: '40px', height: '40px' }} />
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  generateDeviceId: (deviceId) => dispatch(generateDeviceId(deviceId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  updateDevice: (deviceId, updateVal, value) => dispatch(updateDevice(deviceId, updateVal, value)),
  fetchMobileStatus: (deviceId) => dispatch(fetchMobileStatus(deviceId)),
  storeHistory: (history) => dispatch(storeHistory(history)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchUserPlaylists: () => dispatch(fetchUserPlaylists()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
  updateMute: (val) => dispatch(setMute(val)),
  updateShowLogo: (val) => dispatch(setShowLogo(val)),
  updateShowArtDetails: (val) => dispatch(setShowArtworkDetails(val)),
  updateQR: (val) => dispatch(setQR(val)),
  updateSwitchArtwork: (val) => dispatch(setSwitchArtwork(val)),
  updateQuality: (val) => dispatch(set4kQuality(val)),
  updateMatchContent: (val) => dispatch(setMatchContent(val)),
});
export default connect((state) => {
  const { app, device, activePlaylist } = state;
  return {
    app,
    device,
    activePlaylist,
  };
}, mapDispatchToProps)(SplashScreen);
